
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const FeaturesHero = () => {
  const navigate = useNavigate();
  
  return (
    <section className="bg-gradient-to-b from-background to-muted/20 py-16 md:py-20">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Powerful Features <span className="text-primary drop-shadow-sm">Made Simple</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-secondary/80 max-w-3xl mx-auto mb-10 leading-relaxed">
          Everything you need to run your youth program efficiently, all in one place.
          No technical expertise required.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button 
            className="text-lg py-6 px-8 shadow-md bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300" 
            onClick={() => navigate("/pricing")}
          >
            View Pricing
          </Button>
          
          <Button 
            variant="outline" 
            className="text-lg py-6 px-8 border-2 border-primary text-primary hover:bg-primary/10 hover:text-primary hover:border-primary transition-all duration-300"
            onClick={() => navigate("/business-trial")}
          >
            Start Free Trial
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FeaturesHero;
